<template>
  <div class="sp-template">
    <div class="h-title">分拣管理</div>
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="12">
          <h3>分拣机列表</h3>
          <el-button v-if="in_configs(70802)" size="mini" type="text" style="float:right" @click="handleAdd">新建分拣机</el-button>
          <el-table :data="sortingData" v-loading="loading" stripe border style="width: 100%" class="sorting-table">
            <el-table-column label="名称">
              <template slot-scope="scope">
                <el-input size="small" v-if="scope.row.edit" v-model.lazy="scope.row.name" @blur="checkName(scope.row)" :class="[scope.row.isName ? 'error' : '']"></el-input>
                <span v-else>{{scope.row.name}}</span>
                <span v-if="scope.row.isName" style="color: #f56c6c; font-size: 12px;">{{scope.row.nameError}}</span>
              </template>
            </el-table-column>
            <el-table-column label="IP">
              <template slot-scope="scope">
                <el-input size="small" v-if="scope.row.edit" v-model.lazy="scope.row.ip" @blur="checkIP(scope.row)" :class="[scope.row.isIP ? 'error' : '']"></el-input>
                <span v-else>{{scope.row.ip}}</span>
                <span v-if="scope.row.isIP" style="color: #f56c6c; font-size: 12px;">{{scope.row.ipError}}</span>
              </template>
            </el-table-column>
            <el-table-column label="端口数" width="70">
              <template slot-scope="scope">
                <el-input size="small" v-if="scope.row.edit" v-model.lazy="scope.row.totalPort" :disabled="isUsable" :class="[scope.row.isPort ? 'error' : '']"></el-input>
                <span v-else>{{scope.row.totalPort}}</span>
                <span v-if="scope.row.isPort" style="color: #f56c6c; font-size: 12px;">{{scope.row.portError}}</span>
              </template>
            </el-table-column>
            <el-table-column label="分拣配置">
              <template slot-scope="scope">
                <p v-for="(d, i) in scope.row.config" :key="i" class="config__box">
                  <span class="config__left">{{d.id}}</span>
                  <span class="config__right">
                    <span v-for="cod in d.code" :key="cod">{{cod}}</span>
                  </span>
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.edit" size="small" type="text" @click="handleConfig(scope.row)">配置</el-button>
                <i v-if="!scope.row.edit" class="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)"></i>
                <i v-if="!scope.row.delet" class="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></i>
                <el-button v-if="scope.row.edit" size="small" type="primary" @click="createSorting(scope.row)">确定</el-button>
                <el-button v-if="scope.row.cancel" size="small" @click="cancel(scope.$index,scope.row)">取消</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="12">
          <h3>当前分拣机</h3>
          <span>{{name}}</span>
          <sp-transfer :initData="data" :data="nowdata" @channelCodes="getVal" :callbakData.sync="callbakData" :title="['渠道', '端口']" :number="totalPort" limit stripe />
          <el-button v-if="in_configs(70801)" size="small" class="btn-cyan m-t-20" @click="submitSortingConfig">确定</el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import spTransfer from "@/components/sp-transfer.vue";
import axios from "axios";

export default {
  data() {
    return {
      id: "",
      totalPort: 0,
      name: "",
      flag: false,
      isUsable: false, // 禁止更改端口数
      isCreate: false, // 判断是否新建分拣机配置
      loading: true,
      sortingData: [],
      sortingName: "",
      sortingIP: "",
      conditions: {
        totalPort: 0
      },
      callbakData: [],
      sortingConfigForm: {
        sortingId: "",
        config: []
      },
      nowdata: [],
      data: []
    };
  },
  components: { spTransfer },
  created() {
    this.nowdata = this.data;
    setTimeout(() => {
      this.querySorting();
      this.loadChannelType();
      this.loading = false;
    }, 900);
  },
  computed: {},
  methods: {
    getVal(val) {
      for (var i = 0; i < this.callbakData.length; i++) {
        this.callbakData[i].array = [];
      }
    },
    handleAdd() {
      this.flag = false;
      this.isUsable = false;
      this.sortingData.push({
        id: "",
        name: "",
        ip: "",
        totalPort: "",
        status: "1",
        edit: true,
        delet: true,
        cancel: true,
        isName: false,
        isIP: false,
        nameError: "",
        ipError: ""
      });
    },
    //加载分拣机
    querySorting() {
      this.$request1({
        method: 'GET',
        url: '/sorting/query'
      })
        .then(response => {
          let sortingData = response.data;
          let sorting = [];
          for (var i = 0; i < sortingData.length; i++) {
            let sortingConfig = {
              id: "",
              name: "",
              ip: "",
              totalPort: "",
              status: "",
              config: []
            };
            sortingConfig.id = sortingData[i].id;
            sortingConfig.name = sortingData[i].name;
            sortingConfig.ip = sortingData[i].ip;
            sortingConfig.totalPort = sortingData[i].totalPort;
            sortingConfig.status = sortingData[i].status;
            let config = sortingData[i].config;
            for (var j = 0; j < config.length; j++) {
              var configs = { id: "", code: [] };
              configs.id = config[j].portSeq;
              let codes = config[j].code;
              if (codes != null) {
                for (var k = 0; k < codes.length; k++) {
                  for (var c = 0; c < this.data.length; c++) {
                    if (codes[k].trim() == this.data[c].uid) {
                      configs.code.push(this.data[c].label);
                    }
                  }
                }
              }
              sortingConfig.config.push(configs);
            }
            sorting.push(sortingConfig);
          }
          this.sortingData = sorting;
        })
        .catch(error => {
          console.log(error);
        });
    },
    //加载渠道名称
    loadChannelType() {
      this.$request1({
        method: 'GET',
        url: '/system/channel/all'
      })
        .then(response => {
          for (var i = 0; i < response.data.length; i++) {
            let channelType = { uid: "", label: "" };
            channelType.uid = response.data[i].id;
            channelType.label = response.data[i].name;
            this.data.push(channelType);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    checkName(row) {
      if (row.name == "") {
        row.isName = true;
        row.nameError = "请输入分拣机名称";
        return false;
      } else if (row.name == this.sortingName) {
        row.isName = false;
        row.nameError = "";
        return true;
      }

      this.$request1({
        method: 'GET',
        url: '/sorting/check',
        params: {
          name: row.name
        }
      })
        .then(response => {
          if (!response.data.success) {
            row.isName = true;
            row.nameError = "分拣机名称已存在";
            return false;
          }
        })
        .catch(error => {
          console.log(error);
        });

      row.isName = false;
      row.nameError = "";
      return true;
    },
    checkIP(row) {
      if (row.ip == "") {
        row.isIP = true;
        row.ipError = "请输入分拣机IP";
        return false;
      } else if (row.ip == this.sortingIP) {
        row.isIP = false;
        row.ipError = "";
        return true;
      }

      this.$request1({
        method: 'GET',
        url: '/sorting/check',
        params: {
          ip: row.ip
        }
      })
        .then(response => {
          if (!response.data.success) {
            row.isIP = true;
            row.ipError = "分拣机IP已存在";
            return false;
          }
        })
        .catch(error => {
          console.log(error);
        });
      row.isIP = false;
      row.ipError = "";
      return true;
    },
    //新建/修改分拣机
    createSorting(row) {
      if (this.checkName(row) == true && this.checkIP(row) == true) {
        this.$request1({
          method: 'POST',
          url: '/sorting',
          data: JSON.stringify(row),
          headers: { "Content-Type": "application/json" },
          xhrFields: {
            withCredentials: true
          }
        })
          .then(response => {
            row.edit = false;
            this.querySorting();
            this.success();
          })
          .catch(error => {
            console.log(error);
            this.$message.error("操作失败");
          });
      }
    },
    cancel(index, row) {
      this.sortingData.splice(index, 1);
      this.$set(row, "edit", false);
      this.$set(row, "delet", false);
    },
    //编辑
    handleEdit(index, row) {
      console.log("row", row);
      this.flag = true;
      this.isUsable = true;
      this.$set(row, "edit", true);
      this.$set(row, "delet", true);
      this.sortingName = row.name;
      this.sortingIP = row.ip;
      if (row.totalPort == 0) {
        this.isUsable = false;
      }
    },
    //删除分拣机
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该分拣机, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(_ => {
          this.$request1({
            method: 'post',
            url: '/sorting/delete',
            params: {
              id: row.id
            }
          })
            .then(response => {
              this.sortingData.splice(index, 1);
              this.totalPort = 0;
              this.name = "";
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(_ => {});
    },
    //新建分拣机配置
    submitSortingConfig(row) {
      this.sortingConfigForm.config = [];
      for (var i = 0; i < this.callbakData.length; i++) {
        var config = { seq: "", channelCodes: [] };
        config.seq = this.callbakData[i].id;
        var temp = this.callbakData[i].array;
        for (var j = 0; j < temp.length; j++) {
          config.channelCodes.push(temp[j].uid);
        }
        this.sortingConfigForm.config.push(config);
      }

      this.sortingConfigForm.sortingId = this.id;
      console.log(this.sortingConfigForm);
      this.$request1({
        method: 'POST',
        url: '/sortingconfig',
        data: JSON.stringify(this.sortingConfigForm),
        headers: { "Content-Type": "application/json" },
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          row.edit = false;
          this.querySorting();
          if (response.data.message == "update.success") {
            this.$message({
              message: "修改成功",
              type: "success",
              center: true,
              duration: 1500
            });
          } else {
            this.$message({
              message: "添加成功",
              type: "success",
              center: true,
              duration: 1500
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //操作成功
    success() {
      if (this.flag) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //配置
    handleConfig(row) {
      this.id = row.id;
      this.totalPort = row.totalPort;
      this.name = row.name;
      let callbakData = [];
      let code = [];
      for (var i = 0; i < row.config.length; i++) {
        var config = { id: "", array: [] };
        config.id = row.config[i].id;
        let channelCode = row.config[i].code;
        for (var c = 0; c < channelCode.length; c++) {
          code.push(channelCode[c]);
        }
        for (var j = 0; j < this.data.length; j++) {
          for (var k = 0; k < channelCode.length; k++) {
            if (this.data[j].label == channelCode[k]) {
              var array = { uid: "", label: "" };
              array.uid = this.data[j].uid;
              array.label = channelCode[k];
              config.array.push(array);
            }
          }
        }
        callbakData.push(config);
      }
      this.nowdata = JSON.parse(JSON.stringify(this.data));
      for (var j = 0; j < code.length; j++) {
        for (var i = 0; i < this.nowdata.length; i++) {
          if (this.nowdata[i].label == code[j]) {
            this.nowdata.splice(i, 1);
          }
        }
      }
      this.callbakData = callbakData;
    }
  }
};
</script>

<style lang="scss">
h3 {
  color: #666;
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 20px;
}
.error .el-input__inner {
  border-color: red !important;
}
.config__box {
  display: table;
  padding: 0 !important;
}
.config__left {
  display: table-cell;
  padding: 6px 10px;
  border-right: 1px solid #ddd;
}
.config__right {
  display: table-cell;
  width: 100%;
  padding: 6px 10px;
  span {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/system/sorting.vue